// 홈 푸터 사업자 정보(전자상거래법 표시 의무). 항목 이름표는 i18n(home.footer.*), 값은 여기(AC0-230).
export const COMPANY = {
  name: "주식회사 스푼랩스",
  address: "서울특별시 강남구 테헤란로4길 14 (미림타워) 13층",
  ceo: "최혁재",
  bizRegNo: "211-88-94896",
  mailOrderNo: "제2018-서울강남-03177호",
  csPhone: "1661-8726",
  email: "help@hamlak.com",
} as const;
